// @flow
import * as React from 'react';
import { HtmlLink, PhoneIcon, Text } from './styles';

type Props = {
    phoneNumber: string
};

export default function PhoneNumber({ phoneNumber, ...props }: Props) {
    return (
        <HtmlLink {...props} href={`tel:${phoneNumber}`}>
            <PhoneIcon />
            <Text>{phoneNumber}</Text>
        </HtmlLink>
    );
}



// WEBPACK FOOTER //
// ./src/components/widgets/phone-number/index.js